module.exports = __webpack_public_path__ + "static/img/img.a52d80a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img.jpg
// module id = Rx1w
// module chunks = 1